import handleOnBlurRelianceIPAHelper from "./relianceIPAHelper/handleOnBlurRelianceIPAHelper";
import handleOnChangeRelianceIPAHelper from "./relianceIPAHelper/handleOnChangeRelianceIPAHelper";
import { validateRelianceIPAHelper } from "./relianceIPAHelper/validateRelianceIPAHelper";

export const handleChangeHelper = (
  event,
  setFieldValue,
  productName,
  formikValues,
  arrayIndex
) => {
  if (productName === "Reliance IPA") {
    handleOnChangeRelianceIPAHelper(
      event,
      setFieldValue,
      formikValues,
      arrayIndex
    );
  }
};

export const handleOnBlurHelper = (
  event,
  setFieldValue,
  productName,
  formikValues,
  arrayIndex
) => {
  // console.log("productName: ", productName);
  if (productName === "Reliance IPA") {
    handleOnBlurRelianceIPAHelper(
      event,
      setFieldValue,
      formikValues,
      arrayIndex
    );
  }
};

export const validateHelper = (value, field, formik) => {
  const { productName } = field;
  if (productName === "Reliance IPA") {
    return validateRelianceIPAHelper(value, field, formik);
  }

  return null;
};
